import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BulkUploadLayer from "../../components/AirdropCampagin/BulkUploadLayer";

const BulkUploadPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Airdrop Campaign - Bulk Upload" />
                    <BulkUploadLayer />
               </MasterLayout>
          </>
     );
};

export default BulkUploadPage;
